<template>
    <div class="app" :key="monDomaine.id">
        <div class="fond-haut-page">
            <div class="img-fond-haut-page" style="background-image: url('static/css/img/Img/imgFondVins.jpeg');" alt="">

            </div>
            <div class="filtre-haut-page"></div>
        </div>

        <section class="page page-histoire page-section-full">
            <section class="section-page" id="section-domaine">
                <section class="colonne-centre-gauche colonne-centre-gauche-actu">
                    <div class="cadre-description-top-y pl-section">
                        <h1 class="c-gris-blanc">Actualités</h1>
                        <router-link :to="{name: 'Actualite', params: {slug: actualiteUne.slug}}" class="cadre-actualites" v-if="actualiteUne !== undefined">
                            <h3 class="c-gris-blanc">À la une</h3>
                            <div class="actualite-recente">
                                <div class="img-actualite-recente" :style="'background-image: url('+ actualiteUne.image +');'"></div>
                                <div class="infos-actualite-recente">
                                    <h5 class="c-gris-blanc">{{actualiteUne.titre}}</h5>
                                    <template v-if="actualiteUne.date_et_horaire.date_debut.date === actualiteUne.date_et_horaire.date_de_fin.date">
                                        <i class="c-gris-blanc">{{fctDates.date(actualiteUne.date_et_horaire.date_debut.date).date_fr}}</i>
                                        <i class="c-gris-blanc">de {{actualiteUne.date_et_horaire.date_debut.heure.slice(0, 5)}} à {{actualiteUne.date_et_horaire.date_de_fin.heure.slice(0, 5)}}</i>
                                    </template>
                                    <template v-else>
                                        <i class="c-gris-blanc"></i>
                                        <br>
                                        <i class="c-gris-blanc">au {{fctDates.date(actualiteUne.date_et_horaire.date_de_fin.date).date_fr}} - {{actualiteUne.date_et_horaire.date_de_fin.heure.slice(0, 5)}}</i>
                                    </template>
                                </div>
                                <p class="description-actualite-recente c-gris-blanc" v-html="actualiteUne.description"></p>
                            </div>
                        </router-link>

                        <template v-if="mesActualites.length > 0">
                            <h3 class="c-gris-blanc">Autres actualités</h3>
                            <section class="liste-actualites-autres">
                                <router-link :to="{name: 'Actualite', params: {slug: actualite.slug}}" class="autre-actualite" v-for="actualite in mesActualites" :key="'autreActu'+actualite.id">
                                    <div class="img-actualite-autre" :style="'background-image: url('+actualite.image+');'"></div>
                                    <div class="infos-actualite-autre">
                                        <h5 class="c-gris-blanc">{{actualite.titre}}</h5>
                                        <template v-if="actualite.date_et_horaire.date_debut.date === actualite.date_et_horaire.date_de_fin.date">
                                            <i class="c-gris-blanc">{{fctDates.date(actualite.date_et_horaire.date_debut.date).date_fr}}</i>
                                            <i class="c-gris-blanc">de {{actualite.date_et_horaire.date_debut.heure.slice(0, 5)}} à {{actualite.date_et_horaire.date_de_fin.heure.slice(0, 5)}}</i>
                                        </template>
                                        <template v-else>
                                            <i class="c-gris-blanc">du {{fctDates.date(actualite.date_et_horaire.date_debut.date).date_fr}} - {{actualite.date_et_horaire.date_debut.heure.slice(0, 5)}}</i>
                                            <br>
                                            <i class="c-gris-blanc">au {{fctDates.date(actualite.date_et_horaire.date_de_fin.date).date_fr}} - {{actualite.date_et_horaire.date_de_fin.heure.slice(0, 5)}}</i>
                                        </template>
                                    </div>
                                </router-link>
                            </section>
                        </template>

                        <div v-if="mesActualites.length === 0 && actualiteUne === undefined">
                            <p class="c-gris-blanc">Aucune actualité pour le moment</p>
                        </div>

                        <template v-if="listeOnParleDeNous.length > 0">
                            <h2 class="c-gris-blanc">On parle de nous</h2>
                            <section class="liste-actualites-autres">
                                <router-link :to="{name: 'Actualite', params: {slug: actualite.slug}}" class="autre-actualite" v-for="actualite in listeOnParleDeNous" :key="'autreActu'+actualite.id">
                                    <div class="img-actualite-autre" :style="'background-image: url('+actualite.image+');'"></div>
                                    <div class="infos-actualite-autre">
                                        <h5 class="c-gris-blanc">{{actualite.titre}}</h5>
                                        <div class="cadre-recompense-titre">
                                            <img v-if="actualite.source.logo !== false" :src="actualite.source.logo" width="auto" height="50px" alt="">
                                            <p class="c-gris-blanc">{{actualite.source.nom}}</p>
                                        </div>
                                    </div>
                                </router-link>
                            </section>
                        </template>

                        <h2 class="c-gris-blanc">Médailles & récompenses</h2>
                        <section class="liste-recompense" v-if="mesRecompenses.length > 0">
                            <div class="cadre-recompense" v-for="recompense in mesRecompenses" :key="'autreActu'+recompense.id">
                                <div class="cadre-recompense-titre">
                                    <img :src="recompense.icone" width="auto" height="75px" alt="">
                                    <h5 class="c-gris-blanc">{{recompense.nom}} </h5>
                                </div>
                                <div class="liste-vins-recompenses">
                                    <div class="vin-recompense" v-for="vin in fctFiltres.filterInListe(mesVins, recompense.vins, 'id')">
                                        <div :class="'cercle-choix-type-produit cursor cercle-choix-type-produit-'+fctFiltres.filterBy(mesTypesVin, vin.type_vin[0], 'id')[0].type_couleur.toLowerCase()"></div>
                                        <span class="c-gris-blanc">{{fctFiltres.filterBy(mesTypesVin, vin.type_vin[0], 'id')[0].nom}} - {{ vin.propriete.vin.annee }}</span>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section v-else>
                            <p class="text-light">Aucune médaille ou récompense enregistrée.</p>
                        </section>
                    </div>
                </section>

                <section class="colonne-droite colonne-droite-actualite pr-section">
                    <div class="cadre-visite-eco-musee-actualite cadre-actualites">
                        <h4 class="c-gris-blanc">Les visites de l'éco-musée</h4>
                        <span class="c-gris-blanc">
                            Merci de bien vouloir réserver votre visite via le formulaire prévu à cet effet (en cliquant sur le bouton ci-dessous).
                        </span>
                        <!-- <div class="liste-informations-complementaires-produit">
                            <div class="information-complementaire-produit">
                                <div class="div-petit-svg">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="fill-gris-blanc" viewBox="0 0 30 30" fill="none">
                                        <path d="M7.5 26.5H22.5C23.4946 26.5 24.4484 26.1049 25.1517 25.4017C25.8549 24.6984 26.25 23.7446 26.25 22.75V7.75C26.25 7.08696 25.9866 6.45107 25.5178 5.98223C25.0489 5.51339 24.413 5.25 23.75 5.25H21.25V2.75C21.25 2.41848 21.1183 2.10054 20.8839 1.86612C20.6495 1.6317 20.3315 1.5 20 1.5C19.6685 1.5 19.3505 1.6317 19.1161 1.86612C18.8817 2.10054 18.75 2.41848 18.75 2.75V5.25H11.25V2.75C11.25 2.41848 11.1183 2.10054 10.8839 1.86612C10.6495 1.6317 10.3315 1.5 10 1.5C9.66848 1.5 9.35054 1.6317 9.11612 1.86612C8.8817 2.10054 8.75 2.41848 8.75 2.75V5.25H6.25C5.58696 5.25 4.95107 5.51339 4.48223 5.98223C4.01339 6.45107 3.75 7.08696 3.75 7.75V22.75C3.75 23.7446 4.14509 24.6984 4.84835 25.4017C5.55161 26.1049 6.50544 26.5 7.5 26.5ZM6.25 14.625C6.25 14.4592 6.31585 14.3003 6.43306 14.1831C6.55027 14.0658 6.70924 14 6.875 14H23.125C23.2908 14 23.4497 14.0658 23.5669 14.1831C23.6842 14.3003 23.75 14.4592 23.75 14.625V22.75C23.75 23.0815 23.6183 23.3995 23.3839 23.6339C23.1495 23.8683 22.8315 24 22.5 24H7.5C7.16848 24 6.85054 23.8683 6.61612 23.6339C6.3817 23.3995 6.25 23.0815 6.25 22.75V14.625Z"/>
                                    </svg>
                                </div>
                                <p class="c-gris-blanc">13/04/2024</p>
                            </div>

                            <div class="information-complementaire-produit">
                                <div class="div-petit-svg">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="stroke-gris-blanc" width="30" height="30" viewBox="0 0 30 30" fill="none">
                                        <path d="M14.6016 8.60498V14.855L17.7266 12.98M25.8516 14.855C25.8516 21.0682 20.8148 26.105 14.6016 26.105C8.38836 26.105 3.35156 21.0682 3.35156 14.855C3.35156 8.64178 8.38836 3.60498 14.6016 3.60498C20.8148 3.60498 25.8516 8.64178 25.8516 14.855Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <p class="c-gris-blanc">19h30 - 21h00</p>
                            </div>

                            <div class="information-complementaire-produit">
                                <div class="div-petit-svg">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="stroke-gris-blanc fill-gris-blanc" width="30" height="30" viewBox="0 0 30 30" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.8484 9.4501C17.8484 11.0241 16.5725 12.3001 14.9984 12.3001C13.4244 12.3001 12.1484 11.0241 12.1484 9.4501C12.1484 7.87608 13.4244 6.6001 14.9984 6.6001C16.5725 6.6001 17.8484 7.87608 17.8484 9.4501Z" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.7008 19.53C20.7008 21.69 18.1484 23.4504 15.0008 23.4504C11.8532 23.4504 9.30078 21.6948 9.30078 19.53C9.30078 17.3652 11.8532 15.6108 15.0008 15.6108C18.1484 15.6108 20.7008 17.3652 20.7008 19.53Z" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M23.8808 12.0639C23.8929 12.758 23.4842 13.3908 22.8462 13.6649C22.2083 13.9391 21.4679 13.8002 20.9726 13.3136C20.4773 12.827 20.3254 12.0893 20.5882 11.4466C20.8511 10.8039 21.4764 10.384 22.1708 10.3839C23.1068 10.3759 23.8721 11.1279 23.8808 12.0639Z" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.12136 12.0639C6.10918 12.758 6.51799 13.3908 7.15591 13.6649C7.79385 13.9391 8.53421 13.8002 9.02951 13.3136C9.5248 12.827 9.67668 12.0893 9.41386 11.4466C9.15105 10.8039 8.5257 10.384 7.83136 10.3839C6.89536 10.3759 6.12994 11.1279 6.12136 12.0639Z" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M23.0595 21.4342C22.5644 21.3898 22.1271 21.7552 22.0828 22.2503C22.0384 22.7455 22.4038 23.1827 22.8989 23.227L23.0595 21.4342ZM26.3992 19.5298L27.2938 19.6279C27.301 19.5626 27.301 19.4967 27.2938 19.4314L26.3992 19.5298ZM22.8989 15.8338C22.4038 15.8781 22.0384 16.3154 22.0828 16.8105C22.1271 17.3056 22.5645 17.671 23.0595 17.6266L22.8989 15.8338ZM7.09949 23.227C7.59456 23.1827 7.95996 22.7455 7.91563 22.2503C7.87131 21.7552 7.43403 21.3898 6.93895 21.4342L7.09949 23.227ZM3.59922 19.5298L2.70461 19.4314C2.69743 19.4967 2.69742 19.5626 2.70457 19.6279L3.59922 19.5298ZM6.93892 17.6266C7.43399 17.671 7.87128 17.3056 7.91563 16.8105C7.95999 16.3154 7.5946 15.8781 7.09953 15.8338L6.93892 17.6266ZM22.8989 23.227C25.0995 23.4241 27.0532 21.8241 27.2938 19.6279L25.5046 19.4318C25.3707 20.6536 24.2837 21.5438 23.0595 21.4342L22.8989 23.227ZM27.2938 19.4314C27.0525 17.2358 25.099 15.6367 22.8989 15.8338L23.0595 17.6266C24.2835 17.5169 25.3703 18.4066 25.5046 19.6281L27.2938 19.4314ZM6.93895 21.4342C5.71467 21.5438 4.62773 20.6536 4.49387 19.4318L2.70457 19.6279C2.94517 21.8241 4.89889 23.4241 7.09949 23.227L6.93895 21.4342ZM4.49383 19.6281C4.62813 18.4066 5.71493 17.5169 6.93892 17.6266L7.09953 15.8338C4.89947 15.6367 2.94599 17.2358 2.70461 19.4314L4.49383 19.6281Z" stroke="none"/>
                                    </svg>
                                </div>
                                <p class="c-gris-blanc">25 places restantes</p>
                            </div>
                        </div> -->
                        <div class="ligne-bouton-form">
                            <a href="https://eco-musee.domainethibaut.fr/#/reservation" class="btn-primaire bg-gris-blanc c-gris-fonce"><h5>Réservez votre visite</h5></a>
                        </div>
                    </div>
                    <div class="cadre-ouverture-cave-actualite cadre-actualites" >
                        <h4 class="c-gris-blanc">La prochaine ouverture de cave</h4>
                        <div class="liste-informations-complementaires-produit" v-if="prochaineOuverture !== undefined">
                            <div class="information-complementaire-produit">
                                <div class="div-petit-svg">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="fill-gris-blanc" viewBox="0 0 30 30" fill="none">
                                        <path d="M7.5 26.5H22.5C23.4946 26.5 24.4484 26.1049 25.1517 25.4017C25.8549 24.6984 26.25 23.7446 26.25 22.75V7.75C26.25 7.08696 25.9866 6.45107 25.5178 5.98223C25.0489 5.51339 24.413 5.25 23.75 5.25H21.25V2.75C21.25 2.41848 21.1183 2.10054 20.8839 1.86612C20.6495 1.6317 20.3315 1.5 20 1.5C19.6685 1.5 19.3505 1.6317 19.1161 1.86612C18.8817 2.10054 18.75 2.41848 18.75 2.75V5.25H11.25V2.75C11.25 2.41848 11.1183 2.10054 10.8839 1.86612C10.6495 1.6317 10.3315 1.5 10 1.5C9.66848 1.5 9.35054 1.6317 9.11612 1.86612C8.8817 2.10054 8.75 2.41848 8.75 2.75V5.25H6.25C5.58696 5.25 4.95107 5.51339 4.48223 5.98223C4.01339 6.45107 3.75 7.08696 3.75 7.75V22.75C3.75 23.7446 4.14509 24.6984 4.84835 25.4017C5.55161 26.1049 6.50544 26.5 7.5 26.5ZM6.25 14.625C6.25 14.4592 6.31585 14.3003 6.43306 14.1831C6.55027 14.0658 6.70924 14 6.875 14H23.125C23.2908 14 23.4497 14.0658 23.5669 14.1831C23.6842 14.3003 23.75 14.4592 23.75 14.625V22.75C23.75 23.0815 23.6183 23.3995 23.3839 23.6339C23.1495 23.8683 22.8315 24 22.5 24H7.5C7.16848 24 6.85054 23.8683 6.61612 23.6339C6.3817 23.3995 6.25 23.0815 6.25 22.75V14.625Z"/>
                                    </svg>
                                </div>
                                <p class="c-gris-blanc">{{fctDates.date(prochaineOuverture.date).date_fr}}</p>
                                <i class="c-warning" v-if="fctDates.date(prochaineOuverture.date).date_fr === fctDates.date('').date_fr">Aujourd'hui</i>
                            </div>

                            <div class="information-complementaire-produit">
                                <div class="div-petit-svg">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="stroke-gris-blanc" width="30" height="30" viewBox="0 0 30 30" fill="none">
                                        <path d="M14.6016 8.60498V14.855L17.7266 12.98M25.8516 14.855C25.8516 21.0682 20.8148 26.105 14.6016 26.105C8.38836 26.105 3.35156 21.0682 3.35156 14.855C3.35156 8.64178 8.38836 3.60498 14.6016 3.60498C20.8148 3.60498 25.8516 8.64178 25.8516 14.855Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <p class="c-gris-blanc">{{prochaineOuverture.ouverture}} - {{prochaineOuverture.fermeture}}</p>
                                <template v-if="fctDates.date(prochaineOuverture.date).date_fr === fctDates.date('').date_fr">
                                    <!-- <i class="c-warning" v-if="">Aujourd'hui</i> -->
                                    <i class="c-warning" v-if="fctDates.conversionTimeNum(prochaineOuverture.ouverture.slice(0, 2), prochaineOuverture.ouverture.slice(3, 5)) > fctDates.conversionTimeNum(fctDates.date('').heure, fctDates.date('').minute)">Bientôt</i>
                                    <i class="c-warning" v-else-if="fctDates.conversionTimeNum(prochaineOuverture.fermeture.slice(0, 2), prochaineOuverture.fermeture.slice(3, 5)) > fctDates.conversionTimeNum(fctDates.date('').heure, fctDates.date('').minute)">Encore {{ fctDates.conversionTimeNumNbr(fctDates.conversionTimeNum(prochaineOuverture.fermeture.slice(0, 2), prochaineOuverture.fermeture.slice(3, 5)) - fctDates.conversionTimeNum(fctDates.date('').heure, fctDates.date('').minute)) }}</i>
                                </template>
                            </div>
                            <div class="ligne-bouton-form">
                                <router-link to="/contact" class="btn-primaire bg-gris-blanc c-gris-fonce"><span>Prendre rdv à un autre moment</span></router-link>
                            </div>
                        </div>
                        <template v-else>
                            <span class="c-gris-blanc">Aucune ouverture prévue dans les {{monDomaine.reglages.affichage_rdv_cave}} prochains jours, n'hésitez pas à me contacter via le formulaire prévu à cet effet <i>(en cliquant sur le bouton ci-dessous)</i>.</span>
                            <div class="ligne-bouton-form">
                                <router-link to="/contact" class="btn-primaire bg-gris-blanc c-gris-fonce"><h5>Prendre rendez-vous</h5></router-link>
                            </div>
                        </template>
                    </div>
                </section>
            </section>
        </section>

    </div>
</template>

<script>
    import params           from '@/param/param.js'
    import fctFiltres       from '@/functions/filter.js'
    import fctTris          from '@/functions/tris.js'
    import fctFunctions     from '@/functions/functions.js'
    import fctFunctionsSpe  from '@/functions/functions_specifiques.js'
    import fctDates         from '@/functions/date.js'
    
    export default {
        name: 'Contact',
            data () {
                return { 
                    params,
                    fctFiltres,
                    fctTris,
                    fctFunctions,
                    fctFunctionsSpe,
                    fctDates,



                    monDomaine: [],
                    listeActualites: [],
                    listeRecompenses: [],
                    listeOuvertureCave: [],
                    mesVins: [],
                    mesRecompenses: [],
                    mesTypesVin: []
                }
            },

            created(){
                axios.get(params.host+'domaine/v1/listeDomaines')
                .then(response => {
                    this.monDomaine = fctFiltres.filterBy(response.data, params.domaineID, 'id')[0]
                    

                    axios.get(params.host+'actualite/v1/listeActualites')
                    .then(response => {
                        console.log('actu', response.data)
                        this.listeActualites = fctTris.orderByDateDebut(fctFiltres.filterDateType(fctFiltres.filterByDeux(fctFiltres.filterByListe(response.data, this.monDomaine.id, 'domaine'), true, 'affichage', 'affichage'), 'affichage', fctDates.date('').date_en), 'AZ', 'date_et_horaire')
                        
                    }).catch(error => {
                        console.log(error)
                    })

                    axios.get(params.host+'ouvertureCave/v1/listeOuverturesCave')
                    .then(response => {
                        this.listeOuvertureCave = response.data
                    }).catch(error => {
                        console.log(error)
                    })

                    axios.get(params.host+'typeVins/v1/listeTypesVins')
                    .then(response => {
                        this.mesTypesVin = response.data
                    }).catch(error => {
                        console.log(error)
                    })

                    axios.get(params.host+'vin/v1/listeVins')
                    .then(response => {
                        this.mesVins = fctFiltres.filterByListe(response.data, this.monDomaine.id, 'domaine')
                        this.mesVins.forEach(element => {
                            if(element.recompenses !== ""){
                                element.recompenses.forEach(el => {
                                    this.listeRecompenses.push(el)
                                })
                            }
                        });

                        this.listeRecompenses = [...new Set(this.listeRecompenses)]
                        axios.get(params.host+'recompense/v1/listeRecompenses')
                        .then(response => {
                            this.mesRecompenses = fctFiltres.filterSomeListe(response.data, 'id', this.listeRecompenses)
                        }).catch(error => {
                            console.log(error)
                        })
                    }).catch(error => {
                        console.log(error)
                    })
                }).catch(error => {
                    console.log(error)
                })
            },

            computed: {
                listeActuEvenement(){
                    return fctFiltres.filterBy(this.listeActualites, 'On parle de nous', 'type', 'not')
                },

                listeOnParleDeNous(){
                    return fctFiltres.filterBy(this.listeActualites, 'On parle de nous', 'type')
                },

                actualiteUne(){
                    if(fctFiltres.filterByDeux(this.listeActuEvenement, true, 'affichage', 'une').length > 0){
                        return fctFiltres.filterByDeux(this.listeActuEvenement, true, 'affichage', 'une')[0]
                    }else{
                        return this.listeActuEvenement[0]
                    }
                },

                ouvertureCave(){
                    return fctTris.orderByDateDate(fctFiltres.filterRangeDateDate(fctFiltres.filterBy(this.listeOuvertureCave, 'Exceptionnelle', 'type'), fctDates.date('').date_en, fctDates.getDateAnte(fctDates.date('').date_en, -30)), 'AZ')
                },

                ouverturesCaveRegulieres(){
                    if(fctFiltres.filterRangeDateElement(fctFiltres.filterBy(this.listeOuvertureCave, 'Régulière', 'type'), fctDates.getDateAnte('', -this.monDomaine.reglages.affichage_rdv_cave)) !== undefined){
                        return fctFiltres.filterRangeDateElement(fctFiltres.filterBy(this.listeOuvertureCave, 'Régulière', 'type'), fctDates.getDateAnte('', -this.monDomaine.reglages.affichage_rdv_cave))
                    }else{
                        return []
                    }
                },

                prochaineOuverture(){
                    if(this.ouverturesCaveRegulieres.length > 0){
                        this.ouverturesCaveRegulieres.forEach(element => {
                            let prochaineDate = fctDates.getDateJour('', element.jour)
                            element.date = prochaineDate

                            this.ouvertureCave.push(element)
                        })
                    }

                    let ouvertureCave = fctTris.orderByDateDate(this.ouvertureCave, 'AZ')
                    if(ouvertureCave.length > 0){
                        let testWhile = false
                        let i = 0
                        while(ouvertureCave.length > i || testWhile === false){
                            if(ouvertureCave[i].date === fctDates.date('').date_en){
                                if(fctDates.conversionTimeNum(ouvertureCave[i].fermeture.slice(0, 2), ouvertureCave[i].fermeture.slice(3, 5)) >= fctDates.conversionTimeNum(fctDates.date('').heure, fctDates.date('').minute)){
                                    testWhile = true
                                    return ouvertureCave[i]
                                }
                            }else{
                                return ouvertureCave[i]
                            }
                            i++
                        }
                    }
                },

                mesActualites(){
                    if(this.listeActuEvenement.length >= 2 &&  this.actualiteUne !== undefined){
                        return fctFiltres.filterBy(this.listeActuEvenement, this.actualiteUne.id, 'id', 'not')
                    }else{
                        return []
                    }
                }
            },

            methods: {
                
            }
        }
</script>

<style scoped>
    .cls-1 {
        letter-spacing: 0em;
    }

    .cls-2 {
        font-family: Cinzel-Bold, Cinzel;
        font-size: 129.81px;
        font-weight: 800;
    }

    .cls-3 {
        letter-spacing: -.03em;
    }

    .cls-4 {
        letter-spacing: 0em;
    }
</style>


// WEBPACK FOOTER //
// src/components/Actualites.vue